export const ALERT_DURATION = 8000